import { DIAMOND_TYPES } from '../constants/appConstants';

export const VALID_REQUIREMENT_SCOPES = Object.freeze([
  DIAMOND_TYPES.CERTIFIED,
  DIAMOND_TYPES.NON_CERTIFIED,
]);

/**
 * Whether the saved-requirements fetch effect should run.
 */
export function shouldLoadSavedRequirements({ canAccess, isTabActive, savedLoaded }) {
  return Boolean(canAccess && isTabActive && !savedLoaded);
}

export function isValidRequirementsScope(scope) {
  return VALID_REQUIREMENT_SCOPES.includes(scope);
}

/**
 * Build GET params for a single-scope saved requirements load.
 * @param {string} scope
 */
export function savedRequirementsRequestParams(scope) {
  return { scope };
}
